import { Label, DataDisplayEvent } from "@mcleod/components";
import { AutogenLayoutEquipmentTypeList } from "./autogen/AutogenLayoutEquipmentTypeList";

export class EquipmentTypeList extends AutogenLayoutEquipmentTypeList {
    private appliesToLabels = {
        "D": "Driver Item",
        "L": "Trailer",
        "T": "Tractor",
        "X": "Trailer Item",
        "Y": "Tractor Item"
    };

    /** This is an event handler for the onDataDisplay event of labelAppliesTo. */
    labelAppliesToOnDataDisplay(event: DataDisplayEvent) {
        const labelAppliesTo = event.target as Label;
        labelAppliesTo.text = this.appliesToLabels[event.rowData.get("applies_to")] || "Other";
    }
}